// Aquí está el slice de embajador
import { createSlice } from "@reduxjs/toolkit";
import { getAllEmbajadores } from "./embajadorThunks";

const initialState = {
  infoEmbajador: null,
  failureEmbajador: false,
  errorEmbajador: null,
  isLoadingEmbajador: false,
  // Estado para lista completa de embajadores con paginación
  allEmbassadors: [],
  isLoadingAll: false,
  errorAll: null,
  currentPage: 1,
  totalPages: 0,
  totalItems: 0,
  hasNextPage: false,
  hasPrevPage: false,
  currentFilters: {
    search: '',
    enabled: 1,
    sortBy: 'createdAt',
    sortOrder: 'desc'
  }
};

const embajadorSlice = createSlice({
  name: "embajador",
  initialState,
  reducers: {
    embajadorSuccess: (state, action) => {
      state.infoEmbajador = action.payload.infoEmbajador;
      state.failureEmbajador = false;
      state.isLoadingEmbajador = false;
    },
    embajadorFailure: (state, action) => {
      state.failureEmbajador = true;
      state.isLoadingEmbajador = false;
      state.errorEmbajador = action.payload; // mensaje de errorEmbajador
    },
    embajadorReset: (state) => {
      state.infoEmbajador = null;
      state.failureEmbajador = false;
      state.errorEmbajador = null;
      state.isLoadingEmbajador = false;
    },
    setInfoEmbajador: (state, action) => {
      state.infoEmbajador = action.payload;
    },
    // Reducers para lista completa de embajadores
    embajadoresSuccess: (state, action) => {
      // Reemplaza la lista completa (para primera carga o filtros nuevos)
      state.allEmbassadors = action.payload;
      state.isLoadingAll = false;
      state.errorAll = null;
    },
    appendEmbajadores: (state, action) => {
      // Agrega embajadores para infinite scroll (Load More)
      state.allEmbassadors = [...state.allEmbassadors, ...action.payload];
      state.isLoadingAll = false;
    },
    resetEmbajadores: (state) => {
      state.allEmbassadors = [];
      state.currentPage = 1;
      state.totalPages = 0;
      state.totalItems = 0;
      state.hasNextPage = false;
      state.hasPrevPage = false;
      state.isLoadingAll = false;
      state.errorAll = null;
    },
    updatePagination: (state, action) => {
      const { currentPage, totalPages, totalItems, hasNextPage, hasPrevPage } = action.payload;
      state.currentPage = currentPage;
      state.totalPages = totalPages;
      state.totalItems = totalItems;
      state.hasNextPage = hasNextPage;
      state.hasPrevPage = hasPrevPage;
    },
    updateFilters: (state, action) => {
      state.currentFilters = { ...state.currentFilters, ...action.payload };
    }
  },
  extraReducers: (builder) => {
    builder
      // getAllEmbajadores
      .addCase(getAllEmbajadores.pending, (state) => {
        state.isLoadingAll = true;
        state.errorAll = null;
      })
      .addCase(getAllEmbajadores.fulfilled, (state, action) => {
        const { embajadores, pagination } = action.payload;
        
        // Si es página 1, reemplaza; si no, agrega (infinite scroll)
        if (pagination.currentPage === 1) {
          state.allEmbassadors = embajadores;
        } else {
          state.allEmbassadors = [...state.allEmbassadors, ...embajadores];
        }
        
        state.currentPage = pagination.currentPage;
        state.totalPages = pagination.totalPages;
        state.totalItems = pagination.totalItems;
        state.hasNextPage = pagination.hasNextPage;
        state.hasPrevPage = pagination.hasPrevPage;
        state.isLoadingAll = false;
        state.errorAll = null;
      })
      .addCase(getAllEmbajadores.rejected, (state, action) => {
        state.isLoadingAll = false;
        state.errorAll = action.payload || 'Error al cargar embajadores';
      });
  }
});

export const {
  embajadorSuccess,
  embajadorFailure,
  embajadorReset,
  setInfoEmbajador,
  embajadoresSuccess,
  appendEmbajadores,
  resetEmbajadores,
  updatePagination,
  updateFilters
} = embajadorSlice.actions;
export default embajadorSlice.reducer;
